export const CART_LOAD = 'CART_LOAD';
export const CART_LOAD_SUCCESS = 'CART_LOAD_SUCCESS';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_ADD_ITEM_SUCCESS = 'CART_ADD_ITEM_SUCCESS';
export const CART_ADD_ITEM_ERROR = 'CART_ADD_ITEM_ERROR';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_REMOVE_ITEM_SUCCESS = 'CART_REMOVE_ITEM_SUCCESS';
export const CART_REMOVE_ITEM_ERROR = 'CART_REMOVE_ITEM_ERROR';
export const CART_EXPIRED_REQUEST = 'CART_EXPIRED_REQUEST';
export const CART_EXPIRED_SUCCESS = 'CART_EXPIRED_SUCCESS';
export const CART_EXPIRED_ERROR = 'CART_EXPIRED_SUCCESS';
export const CART_EXPIRED_DELETE_REQUEST = 'CART_EXPIRED_DELETE_REQUEST';
export const CART_EXPIRED_DELETE_SUCCESS = 'CART_EXPIRED_DELETE_SUCCESS';
export const CART_EXPIRED_DELETE_ERROR = 'CART_EXPIRED_DELETE_SUCCESS';
export const CART_INVOICE_REQUEST = 'CART_INVOICE_REQUEST';
export const CART_INVOICE_REQUEST_ERROR = 'CART_INVOICE_REQUEST_ERROR';
export const CART_INVOICE_AWATING_APPROVAL = 'CART_INVOICE_AWATING_APPROVAL';
export const CART_INVOICE_APPROVED = 'CART_INVOICE_APPROVED';
export const CART_INVOICE_REFUSED = 'CART_INVOICE_REFUSED';
export const CART_UPDATE_ID = 'CART_UPDATE_ID';
export const CART_MERGE_ALL = 'CART_MERGE_ALL';
export const CART_REPLACE_ALL = 'CART_REPLACE_ALL';
export const CART_RESET_HAS_ERROR = 'CART_RESET_HAS_ERROR';
export const REQUEST_PAYMENT_STATUS_START = 'REQUEST_PAYMENT_STATUS_START';
export const REQUEST_PAYMENT_STATUS_SUCCESS = 'REQUEST_PAYMENT_STATUS_SUCCESS';
export const REQUEST_PAYMENT_STATUS_ERROR = 'REQUEST_PAYMENT_STATUS_ERROR';
